import React, { useEffect } from "react"
import CStatusDot, { StatusColor } from "../elements/c_status_dot"
import OpenCloseIcon from "../elements/open_close_icon"
import DfbButton from "../ui-kit/dfb_button"

export { StatusColor }

/**
 * The accordion expect a list of items in the following structure:
 * <code>
 *   {
 *     title: "Bericht erstellen", // accordion title
 *     status: "red", // status (red, orange, green)
 *     buttonLabel: "open" // button text
 *     buttonLink: "http://go.test // link for button
 *     columns: [
 *       {
 *         key: "Kurs:",
 *         value: "Elite-Jugend-Vorbereitungskurs",
 *       },
 *       {
 *         key: "Bearbeitungszeitraum:",
 *         value: "12.03-2020 – 14.05.2020",
 *       },
 *       {
 *         key: "Buchungsstand:",
 *         value: "freie Plätze vorhanden",
 *       },
 *     ],
 *   }
 * </code>
 *
 * @param items The items array
 * @param statusColumnIndex The optional column index that should show the status
 */
const MUserPanelAccordion = ({ items, statusColumnIndex }) => {
  useEffect(() => {
    // the accordion is never rendered immediately
    // so we explicitly call the auto-init of the UI JavaScript again
    window.window.upgradeAllBehaviours()
  }, [])

  return (
    <ol
      className="c-Accordion c-Accordion--user-panel"
      data-enablemultipleopenitems="true"
    >
      {items.map((item, index) => (
        <li className="c-Accordion-item" data-item={index + 1} key={index + 1}>
          <button className="c-Accordion-button">
            {item.status && <CStatusDot status={item.status} />}
            <span className="c-Accordion-buttonTitle">{item.title}</span>
            <span className="c-Accordion-icon">
              <OpenCloseIcon />
            </span>
          </button>
          <div className="c-Accordion-content">
            <div className="c-Accordion-user-panel">
              <ul className="c-Accordion-user-panel__row">
                {item.columns.map((column, index) => (
                  <li className="c-Accordion-user-panel__column" key={index}>
                    <div className="c-Accordion-user-panel__key">
                      {column.key}
                    </div>
                    <div className="c-Accordion-user-panel__value">
                      {item.status && statusColumnIndex === index && (
                        <CStatusDot status={item.status} />
                      )}
                      {column.value}
                    </div>
                  </li>
                ))}
                {item.buttonLabel && (
                  <li className="c-Accordion-user-panel__column">
                    <DfbButton
                      secondary
                      tagName="a"
                      text={item.buttonLabel}
                      link={item.buttonLink}
                    />
                  </li>
                )}
              </ul>
            </div>
          </div>
        </li>
      ))}
    </ol>
  )
}

export default MUserPanelAccordion
